import { useEffect } from "react";
import { loadScript } from "./helpers";
import { useSession } from "./SessionProvider";

const trackingKeys = {
  ga_key: "UA-208565-1",
  gtag_key: "AW-1072491539",
  gtag_global_key: "AW-1019974146",
  bing_key: "5773337",
};

export default function TrackingScripts() {
  const { session } = useSession();

  useEffect(() => {
    // Google Tag Manager
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-N79N74FG");

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-N79N74FG";
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    // BrightEdge Autopilot
    loadScript("//cdn.bc0a.com/autopilot/f00000000042656/autopilot_sdk.js");

    // GA / gtag - production keys only
    const gtagKey =
      session.countryCode === "us"
        ? trackingKeys.gtag_key
        : trackingKeys.gtag_global_key;
    const gaKey = trackingKeys.ga_key;

    loadScript(`https://www.googletagmanager.com/gtag/js?id=${gtagKey}`);
    loadScript(`https://www.google-analytics.com/analytics.js`);

    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.textContent = `
      window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
      ga('create', '${gaKey}', 'auto');
      ga('send', 'pageview');
    `;
    document.body.appendChild(script);
  }, [session.countryCode]);

  return null;
}
